// @flow

import { DateTime } from "luxon";
import { LocalStorage } from "./storage/index";
import GoogleTagManager from "./GoogleTagManager";

const storeAsyncEvent = (name: Function, value: any) => {
  if (!GoogleTagManager[name]) {
    console.error("Invalid GTM event name given");
    return;
  }
  const storedGTMEvents = LocalStorage.get("ASYNC_G") || {};
  const updatedStoredGTMEvents = { ...storedGTMEvents, [name]: value };
  LocalStorage.set("ASYNC_G", updatedStoredGTMEvents, DateTime.local().plus({ hours: 48 }).toJSDate());
};

const triggerAsyncEvents = () => {
  const storedGTMEvents = LocalStorage.get("ASYNC_G") || {};
  for (const [key, value] of Object.entries(storedGTMEvents)) {
    GoogleTagManager[key](value);
  }
  flushAsyncEvents();
};

const flushAsyncEvents = () => {
  LocalStorage.set("ASYNC_G", null);
};

/**
 * Delays or cancels the triggering of GTM events if the user hasnt consented it
 * @param {string} eventName the exact function name registered in the GoogleTagManager module
 * @param {any} value some additional data associted with the event trigger
 */
const handleAsyncEvent = (eventName: Function, value: any) => {
  const consents = LocalStorage.get("userCookieConsents");
  if (!consents || !consents.functional) {
    storeAsyncEvent(eventName, value);
    return;
  }
  if (consents.functional) GoogleTagManager[eventName](value);
};

export { flushAsyncEvents, storeAsyncEvent, triggerAsyncEvents, handleAsyncEvent };
